import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { AguasComponent } from "../componentes/aguas/aguas.component";
import { MedicionComponent } from "./medicion/medicion.component";
import { SeguimientoContratosComponent } from "./seguimiento-contratos/seguimiento-contratos.component";
import { ReportesComponent } from "./reportes/reportes.component";
import { CuentasComponent } from "./cuentas/cuentas.component";
import { ContratosComponent } from "./contratos/contratos.component";
import { EjecucionComponent } from "./ejecucion/ejecucion.component";
import { EstadoCuentaComponent } from "../componentes/estado-cuenta/estado-cuenta.component";
import { AguaDescuentosComponent } from "../componentes/agua-descuentos/agua-descuentos.component";
import { AuthGuard } from "app/_helpers/auth.guard";


const routes: Routes = [
  {
    path: "",
    children: [
      {
        path: "aguas",
        component: AguasComponent
         ,
      canActivate: [AuthGuard]
      },
    ],
  },
  {
    path: "",
    children: [
      {
        path: "estado-cuenta",
        component: EstadoCuentaComponent
        ,
        canActivate: [AuthGuard]
      },
    ],
  },
 
  {
    path: "",
    children: [
      {
        path: "contratos",
        component: ContratosComponent ,
        canActivate: [AuthGuard]
      },
    ],
  },
  {
    path: "",
    children: [
      {
        path: "cuentas",
        component: CuentasComponent,
        canActivate: [AuthGuard]
      },
    ],
  },
  {
    path: "",
    children: [
      {
        path: "medicion",
        component: MedicionComponent ,
        canActivate: [AuthGuard]
      },
    ],
  },
  {
    path: "",
    children: [
      {
        path: "SeguimientoContratos",
        component: SeguimientoContratosComponent ,
        canActivate: [AuthGuard]
      },
    ],
  },
  
 
  {
    path: "",
    children: [
      {
        path: "reportes",
        component: ReportesComponent ,
        canActivate: [AuthGuard]
      },
    ],
  },
  {
    path: "",
    children: [
      {
        path: "ejecucion",
        component: EjecucionComponent  ,
        canActivate: [AuthGuard]
      },
    ],
  },
  {
    path: "",
    children: [
      {
        path: "agua-descuentos",
        component: AguaDescuentosComponent  ,
        canActivate: [AuthGuard]
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ComercializacionRoutingModule {}
